<cm-section>
    <ng-container cm-icon><i class="far fa-list"></i></ng-container>
    <ng-container cm-title>Activity</ng-container>
    <ng-container cm-content>
        <cm-entity-activity [item]="$item()"></cm-entity-activity>
    </ng-container>
</cm-section>
